<template>
   <svg fill="currentColor" viewBox="0 0 13 12">
      <path d="M12.5 6.75H7.25V12H5.75V6.75H0.5V5.25H5.75V0H7.25V5.25H12.5V6.75Z" />
   </svg>
</template>
